











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {TokenPush} from '@/model/resource/TokenPush'
import {TokenPushCollection} from '@/model/collection/TokenPushCollection'
import {ListTokenPushSchema} from '@/schema/resource/TokenPush/ListTokenPushSchema'
import {CsvTokenPushSchema} from '@/schema/resource/TokenPush/CsvTokenPushSchema'

@Component
export default class ListTokenPushView extends Mixins(MixinQueryRouter) {
  schema = new ListTokenPushSchema()
  collection = new TokenPushCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: TokenPush) {
    Helper.pushByName('editTokenPush', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new TokenPushCollection().clearFilters().addFilter(params)

    await csv.listCsvTokenPush()
    new CsvTokenPushSchema().downloadCsv(csv.all())
  }
}
